import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProfessionalService } from '../../../shared/services/professional.service';

@Component({
  selector: 'app-dialog-history-professional',
  templateUrl: './dialog-history-professional.component.html',
  styleUrls: ['./dialog-history-professional.component.scss']
})
export class DialogHistoryProfessionalComponent implements OnInit {
  isLoading: boolean = true;
  histories: any[] = []

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private readonly professionalService: ProfessionalService) {}

  ngOnInit(): void {
    this.professionalService.getHistoriesById(this.data.professionalId).subscribe(
      (result:any) => {
        this.isLoading = false;
        this.histories = result.histories;
      },
      (error) => console.error('error')
    )
  }

  statusToBr(status: string) {
    switch(status) {
      case 'APPROVED':
          return 'Aprovado';
      case 'REGISTER':
          return 'Cadastro';
      case 'REJECTED':
          return 'Rejeitado';
      case 'PENDING':
          return 'Pendente';
      case 'CFM-VALIDATE':
        return 'Conselho Federal Medicina';
      default:
          return 'Cadastro';
    }
  }
}
